import React, { useContext } from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import { AuthContext } from '../context/AuthContext';

const Navbar = () => {
  const { currentUser } = useContext(AuthContext);

  return (
    <div className='chat-profile'>
      {currentUser ? (
        <>
          <img src={currentUser.photoURL || 'default-avatar.png'} alt='' className="chat-profile__avatar" />
          <div className="chat-profile__info">
            <span className='chat-profile__name'>{currentUser.displayName || 'Anonymous'}</span>
            <span className='chat-profile__email'>{currentUser.email || ''}</span>
          </div>
          <button onClick={() => signOut(auth)} className='chat-profile__logout' title="Logout">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 17L21 12M21 12L16 7M21 12H9M9 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21H9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </>
      ) : (
        <span className="chat-profile__loading">Loading...</span>
      )}
    </div>
  );
};

export default Navbar;